import React from 'react';
import styled from 'styled-components';

const StyledTotalCount = styled('div')`
  margin-right: auto !important;
  opacity: 0.5;
  font-size: 0.75rem;
  @media(max-width:768px){ margin-bottom: 1rem; }
`;

/**
 * Displays the total count and the currently displayed count of items.
 * @param {number} totalCount - The total count of items.
 * @param {number} displayedCount - The count of items currently displayed.
 * @returns {JSX.Element} - The component rendering the counts.
 */
export const TotalCount = ({ totalCount, displayedCount }) => {
  if (totalCount) {
    const noun = totalCount === 1 ? 'item' : 'items';
    return (
      <StyledTotalCount>
        {displayedCount} of {totalCount} {noun}
      </StyledTotalCount>
    );
  }
  return <></>;
};
